module.exports = __webpack_public_path__ + "static/media/visa-mastercard-logo.87a5060d.png";